import { render, staticRenderFns } from "./companyProperty.vue?vue&type=template&id=532c8225&scoped=true"
import script from "./companyProperty.vue?vue&type=script&lang=js"
export * from "./companyProperty.vue?vue&type=script&lang=js"
import style0 from "./companyProperty.vue?vue&type=style&index=0&id=532c8225&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532c8225",
  null
  
)

export default component.exports